// ─── Formatage ────────────────────────────────────────────────────────────────
export const formatEUR = (val) =>
    new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(
        Math.max(0, val ?? 0)
    );

// ─── Sécurité ─────────────────────────────────────────────────────────────────
export const ADMIN_PASSWORD = 'Admin123';

// ─── Étapes du wizard ─────────────────────────────────────────────────────────
export const WIZARD_STEPS = [
    { id: 1, label: 'Récap'       },
    { id: 2, label: 'Ventilation' },
    { id: 3, label: 'Paiement'    },
    { id: 4, label: 'Ticket'      },
];

// ─── Presets de remise (valeurs numériques, 'GRATUIT' = 100 %) ────────────────
export const PRESET_VALUES = [5, 10, 15, 20, 25, 30, 40, 50, 'GRATUIT'];

// ─── Modes de ventilation ─────────────────────────────────────────────────────
// Tous les modes sont toujours disponibles, même après un split.
export const ALL_VENTILATION_MODES = [
    { key: 'total',   label: 'Total'       },
    { key: 'split',   label: 'Diviser'     },
    { key: 'partial', label: 'Par article' },
    { key: 'free',    label: 'Libre'       },
];

// ─── Moyens de paiement ───────────────────────────────────────────────────────
export const PAYMENT_METHODS = [
    { id: 'tpe',    label: 'TPE',         iconKey: 'card',   colorClass: 'blue_background'   },
    { id: 'cash',   label: 'Espèces',     iconKey: 'cash',   colorClass: 'yellow_background' },
    { id: 'resto',  label: 'Resto',       iconKey: 'ticket', colorClass: 'grey_background'   },
    { id: 'nfc',    label: 'Sans Contac', iconKey: 'card',   colorClass: 'purple_background' },
    { id: 'amex',   label: 'AMEX',        iconKey: 'card',   colorClass: 'purple_background' },
    { id: 'cheque', label: 'Chèque',      iconKey: 'card',   colorClass: 'purple_background' },
];

// ─── Arrondi monétaire ────────────────────────────────────────────────────────
export const roundCents = (val) => Math.round((val + Number.EPSILON) * 100) / 100;